import { useCrossFlow } from '@atlassiansox/cross-flow-api-internals';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';

type CrossFlowEligibility = {
	isCrossFlowEligible: boolean;
};

export const useIsCrossFlowEligible = (): CrossFlowEligibility => {
	const { licensedProducts } = useTenantContext();
	const crossFlow = useCrossFlow();

	const tenantHasConfluence = licensedProducts?.confluence === true;
	const isCrossFlowEligible = !tenantHasConfluence && crossFlow.isEnabled;

	return {
		isCrossFlowEligible,
	};
};
